/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateEmailMarkAsUnread } from '../../axios/candidateEmailMarkAsUnread'
import type {
	CandidateEmailMarkAsUnreadError,
	CandidateEmailMarkAsUnreadPathParams,
	CandidateEmailMarkAsUnreadRequest,
	CandidateEmailMarkAsUnreadResponse,
} from '../../types/CandidateEmailMarkAsUnread'

export const candidateEmailMarkAsUnreadMutationKey = () => [{ url: '/candidates/:candidateId/emails/unread' }] as const

export type CandidateEmailMarkAsUnreadMutationKey = ReturnType<typeof candidateEmailMarkAsUnreadMutationKey>

export type CandidateEmailMarkAsUnreadVariables = {
	candidateId: CandidateEmailMarkAsUnreadPathParams['candidateId']
	data: CandidateEmailMarkAsUnreadRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateEmailController.php CandidateEmailController::markAsUnread */
export function useCandidateEmailMarkAsUnread<TContext = unknown>(
	options?: UseMutationOptions<
		CandidateEmailMarkAsUnreadResponse,
		AxiosError<CandidateEmailMarkAsUnreadError>,
		CandidateEmailMarkAsUnreadVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidateEmailMarkAsUnreadMutationKey(),
		mutationFn: ({ candidateId, data }: CandidateEmailMarkAsUnreadVariables) =>
			candidateEmailMarkAsUnread(candidateId, data, config).then(res => res.data),
		...options,
	})
}
